export default {
  autoInit: false,
  stateAttr: "aria-checked",
  stateValue: "mixed"
};
